// extracted by mini-css-extract-plugin
export default {"topNews":"index_topNews_hQrU2","first_title":"index_first_title_fGLEx","second_title":"index_second_title_kLknR"};